import React, { FunctionComponent, useState, useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { useDepartmentStyles } from "./useDepartmentStyles";
import { DepartmentTable } from "./DepartmentView/DepartmentTable";
import { DepartmentForm } from "./DepartmentView/DepartmentForm";
import { useStore } from "../../store";
import { SnackBar } from "../SnackBar";
import { Helmet } from "react-helmet-async";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};
export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export const Departments = () => {
  const classes = useDepartmentStyles();
  const [value, setValue] = React.useState(0);
  const [dept_id, setDept_id] = React.useState(0);
  const [edit_data, setEdit_data] = React.useState({});
  const [departments] = useStore("departments");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [departmentStatus, setDepartmentStatus] = useState<string>("");
  const [showEdit, setShowEdit] = useState<boolean>(false);
  const [viewDepartmentPermission, setViewDepartmentPermission] = useState<
    boolean
  >(false);
  const [editDepartmentPermission, setEditDepartmentPermission] = useState<
    boolean
  >(false);
  const [user] = useStore("auth", "user");
  useEffect(() => {
    const departmentPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 11
    );
    if (user.is_super_admin === true) {
      setViewDepartmentPermission(true);
      setEditDepartmentPermission(true);
    } else {
      if (departmentPermission) {
        if (departmentPermission.is_edit === true) {
          setEditDepartmentPermission(true);
        }
        if (departmentPermission.is_view === true) {
          setViewDepartmentPermission(true);
        }
        if (
          departmentPermission.is_edit === false &&
          departmentPermission.is_view === false
        ) {
          setEditDepartmentPermission(false);
          setViewDepartmentPermission(false);
        }
      }
    }
  });

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const goToEdit = (id: number) => {
    setValue(1);
    setShowEdit(true);
    setDept_id(id);
    const editData =
      departments && departments.find((data: any) => data.department_id === id);

    setEdit_data(editData);
  };

  const goToList = () => {
    setValue(0);
    setShowEdit(false);
  };

  const onCloseSnackbar = () => {
    setDepartmentStatus("");
  };

  return (
    <>
      <Helmet>
        <title>Departments</title>
      </Helmet>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <SnackBar
          status={departmentStatus}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        {/* <Grid item xs={12}>
        <Typography className={classes.departmentTitle}>Departments</Typography>
      </Grid> */}

        <Grid item xs={12} className={classes.root}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab
                label="Department List"
                onClick={() => setShowEdit(false)}
                style={{ display: viewDepartmentPermission ? "" : "none" }}
              />
              <Tab
                label="Edit Department"
                style={{ display: showEdit ? "block" : "none" }}
              />
            </Tabs>
          </AppBar>

          {/* <Grid
          item
          style={{ display: showEdit ? "none" : "block", paddingTop: "1.5em" }}
        >
          <Paper className={classes.searchPaper}>
            <InputBase
              className={classes.SearchInput}
              value={searchText}
              placeholder="Search...."
              inputProps={{ "aria-label": "search " }}
              onChange={(event) => setSearchtext(event.target.value)}
            />
            <IconButton aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid> */}
          <TabPanel value={value} index={0}>
            <DepartmentTable
              departments={departments}
              editDepartmentPermission={editDepartmentPermission}
              goToEdit={goToEdit}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <DepartmentForm
              dept_id={dept_id}
              edit_data={edit_data}
              goToList={goToList}
            />
          </TabPanel>
        </Grid>
      </Grid>
    </>
  );
};
